import { useRoutes } from 'react-router-dom';
import { useApp } from '../utils/AppContext';

import AuthenticationRoutes from './AuthenticationRoutes';
import MdRoutes from './md/MdRoutes';
import AdRoutes from './admin/AdRoutes';

export default function ThemeRoutes() {
    const { appType } = useApp();

    const routes =
        appType === 'ADMIN'
            ? [AdRoutes(), AuthenticationRoutes]
            : [MdRoutes(), AuthenticationRoutes];

    return useRoutes(routes);
}
